module.exports = __webpack_public_path__ + "img/web1_1.a8343fc2.jpg";